import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Modal2 from "../common/Modal2";
import BookPreview from "./BookPreview";
import { getMobileQuery } from "../common/utils";
import { ReactComponent as YourSvg } from "./../images/click-icon.svg";
import ClickOnMeLottie from "../common/ClickMeLottie";

const WrapperStyled = styled.div`
    position: relative;
    width: fit-content;
    cursor: pointer;

    @media (min-width: 550px) {
        &:hover {
            .image-styled-pkd {
                transform: scale(1.1);
                box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
            }
        }
    }
`;

const LastSeenStyled = styled.div`
    position: absolute;
    //background-color: rgba(0, 0, 0, 0.5);
    background-color: #00000073;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: #fff;
    display: grid;
    align-content: center;
    text-align: center;
    font-size: 14px;
`;

const ImageWrapperStyled = styled.div`
    position: relative;
`;

const ImageStyled = styled.div`
    width: 200px;
    height: 200px;
    background-size: cover;
    border-radius: 2px;
    //box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
    box-shadow: rgba(0, 0, 0, 0.2) 0 3px 3px -2px, rgba(0, 0, 0, 0.14) 0 3px 4px 0, rgba(0, 0, 0, 0.12) 0 1px 8px;
    transition: transform 0.3s ease 150ms, box-shadow 0.3s ease 150ms;

    @media (max-width: 780px) {
        width: 250px;
        height: 250px;
    }
    @media (max-width: 550px) {
        width: 100%;
        height: 100%;
    }
`;

const StyledSvg = styled(YourSvg)`
    width: 45px;
    height: 43px;
    position: absolute;
    z-index: 2;
    bottom: 42px;
    right: 6px;
    @media (min-width: 550px) {
        display: none;
    }
`;

const TitleStyled = styled.div`
    width: 200px;
    font-size: 22px;
    margin-top: 10px;
    cursor: pointer;
    text-align: center;
`;

const StyledLottie = styled.div`
    position: absolute;
    bottom: 35px;
    right: 4px;
    @media (min-width: 550px) {
        bottom: 15px;
        right: 0;
    }
`;

const ModalContentStyled = styled.div`
    margin-top: 38px;

    max-width: 670px;
    min-width: 600px;
    min-height: 400px;

    @media (max-width: 780px) {
        min-width: 100%;
        max-width: 100%;
        margin-bottom: 10px;
    }

    img {
        border-radius: 8px;
        width: 300px;
    }

    h3 {
        font-size: 30px;
        margin: 20px;
    }
`;

const BookItem = ({ item, lang, langData, selecteBook, config, isLastSeen }) => {
    const innerWidth = getMobileQuery();
    const isMobile = innerWidth < 550;
    const wrapperRef = useRef(null);

    const [modalOpen, s_modalOpen] = useState(false);
    const [modalInsideOpen, s_modalInsideOpen] = useState(false);
    const [width, s_width] = useState(600);
    const containerRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            s_width(screenWidth < 600 ? screenWidth - 80 : 600);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (wrapperRef?.current) {
            s_width(wrapperRef.current.offsetWidth);
        }
    }, [wrapperRef]);

    const openSelectionFunc = () => {
        s_modalInsideOpen(!modalInsideOpen);
        setTimeout(() => {
            s_modalOpen(!modalOpen);
        }, 500);
    };

    const isFemaleGender = item?.book?.inputData?.gender === "female";
    let imageUrl = item?.imageUrlMale + "?width=450";
    if (isFemaleGender) {
        imageUrl = item?.imageUrlFemale + "?width=450";
    }
    if (item?.book?.approvedData?.length) {
        const cover = item.book.approvedData.find((pp) => pp.pageIndex === -1);
        if (cover) {
            imageUrl = cover.selectedImageUrl + "?width=450";
        }
    }

    let style = {
        backgroundImage: `linear-gradient(to left, rgb(60, 13, 20) 2px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.25) 6px, rgba(255, 255, 255, 0.25) 4px, transparent 8px, transparent 6px, rgba(255, 255, 255, 0.25) 10px, transparent 12px), url(${ imageUrl })`
    };

    const clickIconStyles = { width: "45px", height: "43px", opacity: 0.4 };

    const textStyle = {};
    if (lang === "en") {
        style = {
            backgroundImage: `linear-gradient(to left, rgb(60, 13, 20) 2px, rgba(255, 255, 255, 0.5) 4px, rgba(255, 255, 255, 0.25) 6px, rgba(255, 255, 255, 0.25) 4px, transparent 8px, transparent 6px, rgba(255, 255, 255, 0.25) 10px, transparent 12px), url(${ imageUrl })`
        };
    }

    if (width / 2 < 200) {
        style.width = width / 2;
        style.height = width / 2;
        textStyle.width = width / 2;
    }

    if (isMobile) {
        style.width = 270;
        style.height = 270;
        textStyle.width = 270;
    }

    let fontSize = 22;
    const singleWord = item.title.split(" ").length === 1;
    if (singleWord) {
        if (item.title.length > 16) {
            fontSize = 16;
        }
    } else {
        if (item.title.length > 26) {
            fontSize = 19;
        }
    }

    textStyle.fontSize = fontSize;

    const title = item.title;

    const book = [];
    let selectedBookCoverImage = null;
    let coverDesign = null;
    if (item.book) {
        coverDesign = item.book.template.coverDesign;
        item.book.approvedData.forEach((pp) => {
            if (pp.pageIndex !== -1) {
                book.push({ img: pp.selectedImageUrl });
                book.push({ text: pp.text });
            } else {
                selectedBookCoverImage = pp.selectedImageUrl;
            }
        });
    }

    return (
        <WrapperStyled
            ref={ containerRef }
            tabIndex={ "0" }
            role="button"
            aria-label={ `${ langData.arias.more_info_about_template } ${ title }` }
            onClick={ () => {
                selecteBook(item);
            } }
            onKeyDown={ (e) => {
                if (e.key === " " || e.key === "Enter") {
                    selecteBook(item);
                }
            } }
        >
            <ImageWrapperStyled>
                { isLastSeen && (<LastSeenStyled>{langData.last_seen}</LastSeenStyled>) }
                <ImageStyled style={ style } className={ isLastSeen ? "" : "image-styled-pkd" } />
            </ImageWrapperStyled>
            {/*<StyledSvg />*/ }
            <StyledLottie>
                <ClickOnMeLottie />
            </StyledLottie>

            <TitleStyled
                ref={ textRef }
                style={ textStyle }>{ title }</TitleStyled>

            { modalOpen && (
                <Modal2
                    ariaTitle={ langData.arias.templateInfoDialogTitle }
                    lang={ lang }
                    isOpen={ modalInsideOpen }
                    handleClose={ openSelectionFunc }
                >
                    { item.book && (
                        <ModalContentStyled ref={ wrapperRef }>
                            <BookPreview
                                width={ width }
                                bookCoverData={ {
                                    img: selectedBookCoverImage,
                                    text: title,
                                    coverDesign
                                } }
                                lang={ lang }
                                langData={ langData }
                                book={ book }
                            />
                        </ModalContentStyled>
                    ) }

                    { !item.book && (
                        <ModalContentStyled>
                            <img src={ item?.imageUrl } alt="template" />
                            <h3>{ item.title }</h3>
                            <p>{ item.plot }</p>
                        </ModalContentStyled>
                    ) }
                </Modal2>
            ) }
        </WrapperStyled>
    );
};

export default BookItem;
